/**
 * Created by Viktor on 2016.04.01..
 */
$(function(){
    let auctionId = $('#auction_search').data('auction-id');
    auctionSearch.init(auctionId);

    // $('#order-auction-catalog').fancybox({
    //         autoSize : false,
    //         width    : "70%",
    //         autoHeight : true,
    //         maxWidth : 550
    // });
    //
    // $('#condition-description-request').fancybox({
    //     autoSize : false,
    //     width    : "70%",
    //     autoHeight : true,
    //     maxWidth : 550
    // });
    //
    // $('.condition-description-request').fancybox({
    //     autoSize : false,
    //     width    : "70%",
    //     autoHeight : true,
    //     maxWidth : 550
    // });

    var creationAutoComplete = $('.creationAutoComplete').selectize({
        valueField: 'id',
        labelField: 'title',
        searchField: 'title',
        create: false,
        load: function(query, callback) {
            if (!query.length) return callback();
            $.ajax({
                url: '/ajaxRequest/auction/findByTerm',
                type: 'POST',
                dataType: 'json',
                data: {term: query,id:$('input[name=condition_description_auction_id]').val()},
                error: function() {
                    callback();
                },
                success: function(resp) {
                    callback(resp.data);
                }
            });
        },
        render: {
            item: function(item, escape) {
                return '<div>' +
                    (item.title.length > 25 ? item.title.substring(0,25)+'...' : escape(item.title)) +'</div>';
            }
        }
    });

    if(creationAutoComplete.length) {
        var creationAutoCompleteControl = creationAutoComplete[0].selectize;
        $('.artistAutoComplete').on('clearSelect', function () {
            creationAutoCompleteControl.clear(true);
        });
    }

    $('#condition-description-request-form').submit(function(e){
        $('#condition-description-request-form input').removeAttr('style');
        $('#condition-description-request-form .selectize-input').removeClass('error');
        e.preventDefault();
        if($("#condition_description_subscribe").is(':checked')) {
            $("label[for=condition_description_subscribe]").removeClass('error');
            if($(this).find('select option:selected').val() == ''){
                $(this).find('.selectize-input').addClass('error');
            }
            else {
                $.ajax({
                    url: 'ajaxRequest/auction/conditionDescription',
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        name: $(this).find('input[name=condition_description_name]').val(),
                        email: $(this).find('input[name=condition_description_email]').val(),
                        phone: $(this).find('input[name=condition_description_phone]').val(),
                        auction_id: $(this).find('input[name=condition_description_auction_id]').val(),
                        creation_id: $(this).find('select option:selected').val(),
                    },
                    success: function (msg) {
                        if (msg.data.finished == true) {
                            $('#condition-description-request-container').html($('#conditionDescriptionSuccess').html());
                        } else {
                            for (i = 0; i < msg.data.missing_data.length; i++) {
                                $('#condition-description-request-form [name=' + msg.data.missing_data[i] + ']').css('border', '1px solid #f00');
                            }
                            $('#required-fields-warning').css('color', '#f00');
                        }

                    }
                });
            }
        }
        else{
            $("label[for=condition_description_subscribe]").addClass('error');
        }
    });

    $('#panorama_cover').click(function(){
        var iframe = $(this).data('embed');

        $(iframe).insertAfter($(this));
        $(this).hide();
    });
});

auctionSearch = {
    url: null,
    artist: null,
    price: null,
    tetel: null,
    order: null,
    text: null,
    currency: null,
    auction: null,

    init: function(auction){
        this.url = "ajaxRequest/auction/search";
        this.auction = auction;
        this.currency = 'HUF';

        $('select.search').change(function(){
            auctionSearch[$(this).attr('name')] = $(this).find('option:selected').val();
            auctionSearch.search();
        });

        $('select.search').each(function(){
            auctionSearch[$(this).attr('name')] = $(this).find('option:selected').val();
        });

        $('#auctionSubmit').click(function(){
            auctionSearch.text = $('input[name=text]').val();
            auctionSearch.search();
        });

        $('input[name=text]').keyup(function(e){
            auctionSearch.text = $(this).val();
            if(auctionSearch.text == ""){
                auctionSearch.search();
            }
            if(e.keyCode == '13'){
                auctionSearch.search();
            }
        });

         $('input[name=CUR]').change(function(e){
            auctionSearch.currency = $(this).val();
             auctionSearch.search();
         });

        auctionSearch.text = $('input[name=text]').val();
        auctionSearch.currency = $('.currency_select input[type=radio]:checked').val();


        $('#auction_search .filter-link').click(auctionSearch.filterLinkClick);

        //this._initInfoTooltip();
    },
    filterLinkClick: function(event) {
        event.stopPropagation();
        event.preventDefault();

        var filter = $(event.target).data('filter');
        var value = $(event.target).data('value');

        $(event.target).closest('.dropdown-menu').find('.nav-link.active').removeClass('active');

        if(auctionSearch[filter] == value) { // toggle (off)
            auctionSearch[filter] = '';
        } else {
            auctionSearch[filter] = value;
            $(event.target).addClass('active');
        }

        auctionSearch.search();

        console.log('filterLinkClick',event.target);
    },

    search: function(){
        console.log('auctionSearch.search');
        $('#loadButton').data('request', auctionSearch.url);
        $('#loadButton').data('pagecnt', 0);
        var data = {
            artist:auctionSearch.artist,
            price:auctionSearch.price,
            tetel:auctionSearch.tetel,
            order:auctionSearch.order,
            text: auctionSearch.text,
            auction: auctionSearch.auction,
            //listview: ajaxPager.listview,
            cur: auctionSearch.currency,
            limit: 6,
        };
        $('#loadButton').data('request-data', data);

        loadMore.click($('#loadButton'));
        $('#loadButton').show();

    },

    loadCreation: function(html){
        $('#auction_creation').html(html);
        $('.selectpicker').selectpicker('refresh');
        //PagerInit();
        //ajaxPager._initListView();
    },

    /**
     *
     * @private
     * @deprecated
     */
    _initInfoTooltip : function() {
        /**
         * tooltipster opciók
         */
        var options  = {
            contentAsHTML: true,
            interactive: true,
            position: 'top-left',
            functionInit: function(){
                //return $('<a href="'+$(this).data('editlink')+'" target="_blank">Módosítás adminban</a>')
                return $(this).data('text');
            },
            functionBefore : function(origin, continueTooltip) {
                $(this).addClass('tooltip-hovered');
                continueTooltip();
            },
            functionAfter : function(origin) {
                $(this).removeClass('tooltip-hovered');
            }
        };

        $('.tooltipster').tooltipster(options);
    },
};

$('document').ready(function () {
    $('#order-auction-catalog-form').submit(function(e){
        $('#order-auction-catalog-form input').removeAttr('style');
        e.preventDefault();
        if($("#order_catalog_subscribe").is(':checked')) {
            $.ajax({
                url: 'ajaxRequest/auction/orderCatalog/',
                method: 'POST',
                dataType: 'json',
                data: {
                    order_catalog_name: $(this).find('input[name=order_catalog_name]').val(),
                    order_catalog_email: $(this).find('input[name=order_catalog_email]').val(),
                    order_catalog_phone: $(this).find('input[name=order_catalog_phone]').val(),
                    order_catalog_address: $(this).find('input[name=order_catalog_address]').val(),
                    order_catalog_auction_id: $(this).find('input[name=order_catalog_auction_id]').val()
                },
                success:function(msg){
                    if(msg.data.finished == true) {
                        $('#order-auction-catalog-container').html($('#orderCatalogSuccess').html());
                    } else {
                        for(i=0;i < msg.data.missing_data.length; i++) {
                            console.log(msg.data.missing_data[i]);
                            $('input[name='+msg.data.missing_data[i]+']').css('border', '1px solid #f00');
                        }
                        $('#required-fields-warning').css('color', '#f00');
                    }

                }
            });
        }
    });
});